import { useAuth }         from '@/hooks/useAuth'
import { useAppStore }     from '@/stores/appStore'
import { useKeyboard }     from '@/hooks/useKeyboard'
import { AuthGate }        from '@/components/auth/AuthGate'
import { TopBar }          from '@/components/layout/TopBar'
import { GlobalVault }     from '@/components/vault/GlobalVault'
import { Sidebar }         from '@/components/workspace/Sidebar'
import { MarkdownViewer }  from '@/components/viewer/MarkdownViewer'

// ─── Loading Screen ───────────────────────────────────────────────────────────

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-forge-void flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-forge-ember border-t-transparent rounded-full animate-spin" />
        <p className="text-forge-ash text-xs tracking-[0.2em] uppercase">Initializing</p>
      </div>
    </div>
  )
}

// ─── Workspace Welcome ────────────────────────────────────────────────────────

function WorkspaceWelcome() {
  return (
    <div className="flex items-center justify-center h-full text-center p-8">
      <div className="space-y-3">
        <div className="w-10 h-10 rounded-lg border border-forge-border/50 flex items-center justify-center mx-auto">
          <svg className="w-5 h-5 text-forge-border" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <p className="text-forge-ash text-sm">
          Select a <span className="text-forge-gold font-mono text-xs">.md</span> file
          from the sidebar to begin reading.
        </p>
      </div>
    </div>
  )
}

// ─── App Root ─────────────────────────────────────────────────────────────────

export default function App() {
  const { session, isAuthLoading } = useAuth()
  const view                       = useAppStore((s) => s.view)

  useKeyboard()

  if (isAuthLoading) return <LoadingScreen />
  if (!session)      return <AuthGate />

  return (
    <div className="h-screen flex flex-col bg-forge-void overflow-hidden">
      <TopBar />

      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar: shown whenever a repo is selected */}
        {view !== 'vault' && <Sidebar />}

        {/* Main Content */}
        <main className="flex-1 overflow-auto">
          {view === 'vault'     && <GlobalVault />}
          {view === 'workspace' && <WorkspaceWelcome />}
          {view === 'viewer'    && <MarkdownViewer />}
        </main>
      </div>
    </div>
  )
}
